export const CONTENTFUL_BASE_URL = 'https://preview.contentful.com/spaces/a9mooz6ri0vn/environments/master/entries';
export const CONTENTFUL_ASSETS_URL = 'https://preview.contentful.com/spaces/a9mooz6ri0vn/environments/master/assets/';
